import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Sila3DIntro } from '@/components/public/Sila3DIntro';
import { Button } from '@/components/ui/button';

export default function IntroTest() {
  const [showIntro, setShowIntro] = useState(true);

  return (
    <div className="min-h-screen bg-background">
      {showIntro && <Sila3DIntro onComplete={() => setShowIntro(false)} />}

      <div className="mx-auto flex min-h-screen max-w-3xl flex-col items-start justify-center gap-4 px-6" data-testid="intro-test-content">
        <h1 className="font-display text-4xl font-bold">Contenuto dell'app</h1>
        <p className="text-muted-foreground">L'intro cinematografica 3D è terminata e ha ceduto il posto al contenuto. Questa è la pagina di test.</p>
        <div className="flex gap-3">
          <Button onClick={() => setShowIntro(true)} data-testid="intro-replay">Rivedi l'intro</Button>
          <Button asChild variant="outline"><Link to="/parchi">Vai ai Parchi</Link></Button>
        </div>
      </div>
    </div>
  );
}
